module.exports = __webpack_public_path__ + "img/acaki1.b13de273.jpg";